import { Box, Grid } from "@material-ui/core";
import { useContext } from "react";
import PersonalDataComponent from "../../../components/materialui/Shared/PersonalDataComponent";
import AddressDataComponent from "../../../components/materialui/Shared/AddressDataComponent";
import { MedicoTerceiroContext } from "../../../../context/MedicoTerceiroContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import Controls from "../../../../components/controls/Controls";
import { TipoCadastroMedicoTerceiroOptions } from "../../../../data/TipoCadastroMedicoTerceiro";
import { RegiaoOptions } from "../../../../data/Regiao";
import { Alert, AlertTitle } from "@material-ui/lab";

export default function PersonalAddressDataStep() {
  const { state, dispatch } = useContext(MedicoTerceiroContext);

  const onInputPersonalChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  const onInputAddressChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  const onRadioGroupChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  return (
    <div>
      <Steps.StepTitle text="Dados Pessoais" />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Controls.RadioGroup
            name="Region"
            label="Região"
            value={state.PersonalAddressDataForm.Region.Value}
            onChange={(e) => {
              onRadioGroupChange(
                "Region",
                state.PersonalAddressDataForm,
                e.target.value
              );
            }}
            items={RegiaoOptions}
            error={state.PersonalAddressDataForm.Region.Error}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controls.RadioGroup
            name="TypeRegistration"
            label="Tipo Cadastro"
            value={state.PersonalAddressDataForm.TypeRegistration.Value}
            onChange={(e) => {
              onRadioGroupChange(
                "TypeRegistration",
                state.PersonalAddressDataForm,
                e.target.value
              );
            }}
            items={TipoCadastroMedicoTerceiroOptions}
            error={state.PersonalAddressDataForm.TypeRegistration.Error}
          />
        </Grid>

        {state.PersonalAddressDataForm.TypeRegistration.Value === "MedicoTerceiro" ?
          (
            <Grid item xs={6} sm={6}>
              <Controls.Input
                name="Setor"
                label="Setor *"
                maxLength={100}
                placeholder={"Informe o Setor"}
                value={state.PersonalAddressDataForm.Sector.Value}
                onChange={(e) => {
                  onInputPersonalChange(
                    "Sector",
                    state.PersonalAddressDataForm,
                    e.target.value
                  );
                }}
                onBlur={(e) => {
                  onInputPersonalChange(
                    "Sector",
                    state.PersonalAddressDataForm,
                    e.target.value
                  );
                }}
                error={state.PersonalAddressDataForm.Sector.Error}
              />
            </Grid>
          ) : null}
      </Grid>

      <Box mt={2}>
        <PersonalDataComponent
          PersonalDataForm={state.PersonalDataForm}
          onInputChange={onInputPersonalChange}
        />
      </Box>

      <Steps.StepTitle text="Endereço Residencial" />

      <Box mt={4}>
        <AddressDataComponent
          AddressDataForm={state.AddressDataForm}
          onInputChange={onInputAddressChange}
        />
      </Box>

    </div>
  );
}
